// src/components/Store/OrderSuccess.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PublicLayout from '../public/PublicLayout';
import { ARCA_COLORS } from '../../constants/colors';

const OrderSuccess = ({ user, onLogout }) => {
  const location = useLocation();
  const { orderNumber, total } = location.state || {};

  return (
    <PublicLayout>
      <div style={{ backgroundColor: ARCA_COLORS.light, minHeight: '100vh' }} className="py-5">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">

              {/* Success Icon & Header */}
              <div className="text-center mb-5">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                  style={{
                    width: '120px',
                    height: '120px',
                    backgroundColor: '#d4edda',
                    border: `4px solid ${ARCA_COLORS.success}`
                  }}
                >
                  <i className="bi bi-check-circle-fill" style={{ fontSize: '4rem', color: ARCA_COLORS.success }}></i>
                </div>

                <h1 className="display-4 fw-bold mb-3" style={{ color: ARCA_COLORS.secondary }}>
                  Order Confirmed!
                </h1>
                <p className="lead text-muted">
                  Thank you for your purchase. Your order has been successfully placed and is being processed.
                </p>
              </div>

              {/* Order Details Card */}
              <div className="card border-0 shadow-lg mb-4">
                <div
                  className="card-header text-white py-3"
                  style={{ backgroundColor: ARCA_COLORS.primary }}
                >
                  <h5 className="mb-0">
                    <i className="bi bi-receipt me-2"></i>Order Details
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="border-start border-4 ps-3" style={{ borderColor: ARCA_COLORS.primary + ' !important' }}>
                        <small className="text-muted d-block mb-1">Order Number</small>
                        <h6 className="mb-0 fw-bold" style={{ color: ARCA_COLORS.secondary }}>
                          {orderNumber || 'Processing...'}
                        </h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="border-start border-4 ps-3" style={{ borderColor: ARCA_COLORS.accent + ' !important' }}>
                        <small className="text-muted d-block mb-1">Total Amount</small>
                        <h6 className="mb-0 fw-bold" style={{ color: ARCA_COLORS.secondary }}>
                          ${total || '0.00'}
                        </h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="border-start border-4 ps-3" style={{ borderColor: ARCA_COLORS.success + ' !important' }}>
                        <small className="text-muted d-block mb-1">Order Date</small>
                        <h6 className="mb-0 fw-bold" style={{ color: ARCA_COLORS.secondary }}>
                          {new Date().toLocaleDateString()}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* What's Next Card */}
              <div className="card border-0 shadow-sm mb-4" style={{ borderLeft: `5px solid ${ARCA_COLORS.accent}` }}>
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-3" style={{ color: ARCA_COLORS.secondary }}>
                    <i className="bi bi-info-circle-fill me-2" style={{ color: ARCA_COLORS.accent }}></i>
                    What's Next?
                  </h5>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <i className="bi bi-envelope-check-fill me-3 mt-1" style={{ color: ARCA_COLORS.primary, fontSize: '1.5rem' }}></i>
                        <div>
                          <h6 className="fw-bold mb-1">Email Confirmation</h6>
                          <p className="text-muted small mb-0">Check your inbox for order details and receipt</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <i className="bi bi-truck me-3 mt-1" style={{ color: ARCA_COLORS.accent, fontSize: '1.5rem' }}></i>
                        <div>
                          <h6 className="fw-bold mb-1">Shipping Updates</h6>
                          <p className="text-muted small mb-0">We'll email tracking info when your order ships</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <i className="bi bi-clock-history me-3 mt-1" style={{ color: ARCA_COLORS.primary, fontSize: '1.5rem' }}></i>
                        <div>
                          <h6 className="fw-bold mb-1">Delivery Time</h6>
                          <p className="text-muted small mb-0">Standard shipping takes 5-7 business days</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <i className="bi bi-box-seam me-3 mt-1" style={{ color: ARCA_COLORS.accent, fontSize: '1.5rem' }}></i>
                        <div>
                          <h6 className="fw-bold mb-1">Track Your Order</h6>
                          <p className="text-muted small mb-0">Monitor status in your account dashboard</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="row g-3">
                <div className="col-md-6">
                  <Link
                    to="/store"
                    className="btn btn-lg w-100 text-white"
                    style={{
                      backgroundColor: ARCA_COLORS.primary,
                      borderColor: ARCA_COLORS.primary
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = ARCA_COLORS.secondary}
                    onMouseOut={(e) => e.target.style.backgroundColor = ARCA_COLORS.primary}
                  >
                    <i className="bi bi-shop me-2"></i>
                    Continue Shopping
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/dashboard"
                    className="btn btn-lg btn-outline-secondary w-100"
                    style={{
                      borderColor: ARCA_COLORS.secondary,
                      color: ARCA_COLORS.secondary
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = ARCA_COLORS.secondary;
                      e.target.style.color = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = ARCA_COLORS.secondary;
                    }}
                  >
                    <i className="bi bi-speedometer2 me-2"></i>
                    View Dashboard
                  </Link>
                </div>
              </div>

              {/* Support Section */}
              <div className="text-center mt-5">
                <p className="text-muted mb-2">
                  <i className="bi bi-question-circle me-2"></i>
                  Need help with your order?
                </p>
                <a
                  href="mailto:support@africaresp.org"
                  className="fw-bold"
                  style={{ color: ARCA_COLORS.accent, textDecoration: 'none' }}
                >
                  Contact Support
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default OrderSuccess;